import ProductPreviewView from './ProductPreviewView'

export default ProductPreviewView
